import moment from "moment";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Box, Grid, Grid2, Typography } from "@mui/material";
import { InputSelectFieldGrid, TableData } from "../../../components";
import { getProviderCredBalance, getTodayProviderTransactions } from "../../../services/admin/providerService";
import { setDetailedReportFilters } from "redux/slices/report/reportSlice";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { currencyFormatter, currencyIntFormatter } from "helpers/util";
import { Loader } from "rsuite";
import { setTitle } from "redux/slices/uiSlice";
import './MonitorProviderTransactionsScreen.css'

const MonitorProviderTransactionsScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(true)
  const { control, watch } = useForm({ defaultValues: { time: 10 } });
  const [time, setTime] = useState(10)
  const [start, setStart] = useState(false)
  const [balances, setBalances] = useState([])
  const selectOpenRef = useRef(false)

  useEffect(() => {
    dispatch(setTitle('Monitor de Proveedores'));
    getTodayProviderTransactions().then((response) => {
      setList(response)
      setStart(true)
      getProviderCredBalance(response.map(({ id }) => id)).then((response) => setBalances(response))
    }).finally(() => setLoading(false))
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!start) return;
    const interval = setInterval(() => {
      if (selectOpenRef.current) return;
      setTime(prevTime => {
        if (watch('time') === prevTime + 1) {
          getTodayProviderTransactions().then(response => {
            setList(response)
            getProviderCredBalance(response.map(({ id }) => id)).then((response) => setBalances(response))
          });
          return 0;
        }
        return prevTime + 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [start, watch('time')]);

  useEffect(() => {
    setTime(0);
  }, [watch('time')]);

  const handlerSelectProvider = (credential) => {
    navigate('/reportes/detallado', {
      state: {
        type: 1,
        date: [new Date(), new Date()],
        credential,
      }
    })
  }

  return (
    <>
      {
        loading ? (
          <Grid2 textAlign={'center'} mt={10}>
            <Loader size="lg" content="Cargando..." vertical />
          </Grid2>
        ) : (
          <Box className="monitor" mt={-2}>
            <Grid container className="toolbar" mx={-4}>
              <Grid item xs={6} alignContent={"center"}>
                <Typography sx={{ fontWeight: 'bold' }} >
                  Se actualizará en {watch('time') - time} segundo{watch('time') - time > 1 ? 's' : ''}
                </Typography>
              </Grid>
              <Grid item container xs={6} justifyContent={"end"}>
                <InputSelectFieldGrid
                  xs={3}
                  control={control}
                  name={'time'}
                  label={'Tiempo de actualización'}
                  onOpen={() => { selectOpenRef.current = true }}
                  onClose={() => { selectOpenRef.current = false }}
                  data={[
                    { id: 1, name: 1 },
                    { id: 5, name: 5 },
                    { id: 10, name: 10 },
                    { id: 15, name: 15 },
                    { id: 30, name: 30 },
                    { id: 60, name: 60 },

                  ]}
                // onSelect={(value) => onSelect(value, setValue)}
                />
              </Grid>
            </Grid>
            <Grid container spacing={5} mt={0}>
              {
                list.map(({ id, name, txns, aprovedPercent, deniedPercent }, key) => {
                  const balance = balances.find(({ id: idBalance }) => idBalance === id)?.balance;
                  const amount = balance?.disponiblePorcentual || balance?.saldo || balance?.balance;
                  return (
                    <Grid item xs={6} md={4} key={key} >
                      <Box sx={{
                        border: '1px solid #041C3F',
                        backgroundColor: '#fff',
                        borderTopLeftRadius: 8,
                        borderTopRightRadius: 8,
                        minHeight: 90,
                      }} >
                        <Typography
                          pb={1}
                          pt={1}
                          fontWeight={'bold'}
                          textAlign={'center'}
                          fontSize={16}
                          onClick={() => handlerSelectProvider(id)}
                          style={{ cursor: 'pointer' }}
                        >
                          {name}
                        </Typography>
                        <Grid container justifyContent={'center'}>
                          <Typography fontSize={16} color='#94F2A4' textAlign={'center'} mb={0} pb={0} mr={1}>
                            {aprovedPercent.toFixed(2)}%
                          </Typography> |
                          <Typography fontSize={16} color='#F29496' textAlign={'center'} mb={0} pb={0} ml={1}>
                            {deniedPercent.toFixed(2)}%
                          </Typography>
                        </Grid>
                        {amount && <Grid container justifyContent={'center'}>
                          <Typography textAlign={'center'} mb={0} pb={0} fontSize={16} fontWeight={'bold'}>
                            Saldo: {currencyFormatter.format(Math.abs(amount))}
                          </Typography>
                        </Grid>}
                      </Box>
                      <TableData
                        loading={loading}
                        pagination={false}
                        autonumber={false}
                        rowsPerPageOpt={10}
                        headerStyle={{
                          // fontSize: 10,
                          padding: .5,
                        }}
                        dataRows={(new Array(15).fill({})).map((item, i) => txns[i] || {}).map((item) => ({
                          ...item,
                          style: item?.ProviderResponseCode ? {
                            color: item?.ProviderResponseCode != "00" && 'red',
                            padding: .5,
                          } : { padding: .5, }
                        }))}
                        dataTitle={[
                          "Hora",
                          name.includes('pds') ? "Compañia" : "Operadora",
                          name.includes('pds') ? "Referencia" : "Número",
                          name.includes('pds') ? "Monto" : "Producto",
                        ]}
                        formatter={({
                          createdAt,
                          operator,
                          phoneNumber,
                          reference,
                          productId,
                          amount
                        }) => ([
                          createdAt ? moment(createdAt).format('HH:mm:ss') : '-',
                          operator ? { type: 'text', value: operator, maxWidth: 80 } : '-',
                          (reference || phoneNumber) ? (name.includes('pds') ? reference : phoneNumber) : '-',
                          (amount || productId) ? (name.includes('pds') ? currencyIntFormatter.format(amount) : productId) : '-',
                        ])}
                      />
                    </Grid>
                  )
                })
              }
            </Grid>
          </Box>
        )
      }

    </>
  );
};

export default MonitorProviderTransactionsScreen;
